module.exports = __webpack_public_path__ + "0bf17aa38a2847bb680db8dcc904f4e7.MP3";